export default __webpack_public_path__ + "static/media/logo-update23.1cfd45a7.png";